import React from 'react';
import styles from '../../styles/OurBoxes.module.css';

export function AgeGroupImageButtonAlt(props: {
  readonly isSelected?: boolean;
  readonly title: string;
  readonly image: string;
  readonly onClick: () => void;
}) {
  return (
    <div
      className={`${props.isSelected ? styles.ageGroupOptionAltSelected : ''} ${styles.ageGroupOptionAlt}`}
      onClick={props.onClick}
    >
      <div
        style={{
          backgroundImage: `url("${props.image}")`,
        }}
        className={styles.ageGroupOptionAltImage}
      />
      <h6 className="pt-3 my-0">{props.title}</h6>
    </div>
  );
}
